<template>
  <div class='h-ainfoBg'>
    <div class='h-ainfo' :style="styleColorVar">
      <span class='icon hero-icon hero-icon-detailcode'></span>
      <span>{{$t('Alarm.totalNumberOfAlarms')}}： {{ totalAlarmCount }}</span>
      <span><span class='h-icon h-icon-dot critical'></span>{{$t('Alarm.numberOfCriticalAlarms')}}： {{ criticalAlarmCount }}</span>
      <span><span class='h-icon h-icon-dot major'></span>{{$t('Alarm.numberOfMajorAlarms')}}： {{ majorAlarmCount }}</span>
      <span><span class='h-icon h-icon-dot minor'></span>{{$t('Alarm.numberOfMinorAlarms')}}： {{ minorAlarmCount }}</span>
      <span><span class='h-icon h-icon-dot warning'></span>{{$t('Alarm.numberOfWarningAlarms')}}： {{ warningAlarmCount }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'currentAlarmCount',
  props: {
    roleNe: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      totalAlarmCount: '',
      criticalAlarmCount: '',
      majorAlarmCount: '',
      minorAlarmCount: '',
      warningAlarmCount: '',
      queryConditions: {
        systemId: '1'
      },
      styleColorVar:{},

    };
  },
  watch: {
     roleNe() {
       this.getAlarmCount();
     }
  },
  methods: {
    getAlarmCount(args) {
      const This = this;
      let conditionsStr = '';
      let keywordsStr = '';
      let principal = sessionStorage.getItem('principal');
      let user = JSON.parse(principal);
      let userId = user.userId;
      if (args) {
        conditionsStr = args.conditions;
        keywordsStr = args.keywords;
      }
      This.$axios.post('/lte/ems/fm/alarmcurrent/alarmCount', {
        conditions: conditionsStr,
        keywords: keywordsStr,
        roleNe: This.roleNe,
        userId: userId
      }).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          This.updateCount(response.data.resultVal.alarmCountInfo);
        }
      });
    },
    addCount(countInfo) {
      const This = this;
      This.totalAlarmCount += countInfo.totalAlarmCount;
      This.criticalAlarmCount += countInfo.criticalAlarmCount;
      This.majorAlarmCount += countInfo.majorAlarmCount;
      This.minorAlarmCount += countInfo.minorAlarmCount;
      This.warningAlarmCount += countInfo.warningAlarmCount;
    },
    updateCount(countInfo) {
      const This = this;
      This.totalAlarmCount = countInfo.totalAlarmCount;
      This.criticalAlarmCount = countInfo.criticalAlarmCount;
      This.majorAlarmCount = countInfo.majorAlarmCount;
      This.minorAlarmCount = countInfo.minorAlarmCount;
      This.warningAlarmCount = countInfo.warningAlarmCount;
    }
  },
  mounted() {
      this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));

  },
};
</script>
